import React from 'react'
import {Button} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router'

type Props = {
    onClick?: () => void
    title?: string
    disabled?: boolean
}

export default function CancelButton({ onClick, title, disabled }: Props) {
    const { t } = useTranslation()
    const history = useHistory()

    return (
        <Button title={title ?? t('general.cancel')} color='secondary'
                disabled={disabled ?? false}
                onClick={() => (onClick ? onClick() : history.goBack())}>
            {title ?? t('general.cancel')}
        </Button>
    )
}
